'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cwUi = require('cw-ui');

var _AutomationName = require('../../../services/AutomationName');

var _AutomationName2 = _interopRequireDefault(_AutomationName);

var _reactIntl = require('react-intl');

var _ClickTracker = require('../../../services/ClickTracker');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NumberField = function (_React$Component) {
  (0, _inherits3.default)(NumberField, _React$Component);

  function NumberField(props) {
    (0, _classCallCheck3.default)(this, NumberField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NumberField.__proto__ || (0, _getPrototypeOf2.default)(NumberField)).call(this, props));

    _this.formatNumber = function (value) {
      var formatNumber = _this.props.intl.formatNumber;


      var newVal = value;
      if (typeof value !== "number") {
        newVal = parseFloat(value);
      }
      if (!isNaN(newVal)) {
        return formatNumber(newVal, { maximumFractionDigits: _this.props.maximumFractionDigits, minimumFractionDigits: _this.props.minimumFractionDigits });
      } else {
        return value;
      }
    };

    _this.getDecimalSeparator = function () {
      var formatNumber = _this.props.intl.formatNumber;

      var valueString = formatNumber(1000.99);

      var lengthCounter = valueString.length - 1;

      while (valueString.charAt(lengthCounter) === '9') {
        lengthCounter--;
      }
      ;
      return valueString.charAt(lengthCounter);
    };

    _this.getNegativeSymbol = function () {
      var formatNumber = _this.props.intl.formatNumber;

      var valueString = formatNumber(-1);

      var negative = valueString.charAt(0);

      if (negative === '1') {
        negative = valueString.charAt(1);
      }

      return negative;
    };

    _this.getNegativePosition = function () {
      var formatNumber = _this.props.intl.formatNumber;

      var valueString = formatNumber(-1);
      var negativeAtStart = true;
      var negative = valueString.charAt(0);

      if (negative === '1') {
        negative = valueString.charAt(1);
        negativeAtStart = false;
      }
      return negativeAtStart;
    };

    _this.getThousandSeparator = function () {
      var formatNumber = _this.props.intl.formatNumber;

      var valueString = formatNumber(1000.00);
      return valueString.charAt(valueString.indexOf("1") + 1);
    };

    _this.formatOnFocus = function (value) {
      if (_this.props.noSeperator) {
        return value;
      }
      return value.split(_this.state.thousands).join("");
    };

    _this.getAutomationName = function () {
      return _AutomationName2.default.get('num', _this.props.automationName);
    };

    _this.handleChange = function (value) {
      (0, _ClickTracker.addEditTrack)(_this.getAutomationName());
      _this.props.onChange(value);
    };

    _this.state = {
      decimal: _this.getDecimalSeparator(),
      thousands: _this.getThousandSeparator(),
      negative: _this.getNegativeSymbol(),
      negativeAtStart: _this.getNegativePosition()
    };
    return _this;
  }

  (0, _createClass3.default)(NumberField, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_cwUi.CwNumberField, (0, _assign2.default)({}, this.props, {
        cwId: this.getAutomationName(),
        onChange: this.props.onChange ? this.handleChange : undefined,
        formatNumber: this.formatNumber,
        negative: this.state.negative,
        decimal: this.state.decimal,
        thousands: this.state.thousands,
        negativeAtStart: this.state.negativeAtStart,
        formatOnFocus: this.formatOnFocus
      }));
    }
  }]);
  return NumberField;
}(_react2.default.Component);

NumberField.propTypes = (0, _assign2.default)({
  /**
   * Element id used as selection and search for automation testing
   */
  automationName: _propTypes2.default.string,
  /**
   * The maximuim number of digits allowed after a decimal
   */
  maximumFractionDigits: _propTypes2.default.number,
  /**
   * The minimum number of digits allowed after a decimal
   */
  minimumFractionDigits: _propTypes2.default.number
}, _cwUi.CwNumberField.propTypes, {
  /**
    * Override required prop from spread, these props should never
    * be set when using the number field as they are set in this 
    * component above
    */
  negative: _propTypes2.default.string,
  decimal: _propTypes2.default.string,
  thousands: _propTypes2.default.string,
  formatNumber: _propTypes2.default.func
});

NumberField.defaultProps = {
  maximumFractionDigits: 20,
  minimumFractionDigits: 0,
  selectAllOnFocus: true
};

exports.default = (0, _reactIntl.injectIntl)(NumberField);


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/managewidgets/components/numberfield/NumberField.js
// module id = 786
// module chunks = 10